import { getPlanLabel } from "./plans.js";

export function resolveGiftedDays({ giftedDays, giftedMonths = 0 } = {}) {
  if (Number.isFinite(giftedDays)) return Math.max(0, Math.round(giftedDays));
  return Number.isFinite(giftedMonths) ? Math.max(0, Math.round(giftedMonths * 31)) : 0;
}

export function onboardingGiftLabel(gift = {}) {
  const days = resolveGiftedDays(gift);
  if (days === 38) return "One free month, plus a referral week";
  if (days === 31) return "1 free month of Fun";
  if (days > 0 && days % 31 === 0) return `${days / 31} free months of Fun`;
  return days > 0 ? `${days} days` : "Fun plan";
}

export function buildIncludedPlanCard(planSlug, { giftedDays, giftedMonths = 1, referrerName = "" } = {}) {
  const days = resolveGiftedDays({ giftedDays, giftedMonths });
  return {
    slug: planSlug, name: getPlanLabel(planSlug), headlinePrice: "$0", originalHeadlinePrice: "",
    suffix: days % 31 === 0 ? `for ${days / 31} mo` : `${days} days`,
    billedNow: days === 38 && referrerName ? "You both get a week" : "A week when they join. A month of their plan when they first pay.",
    promoLabel: "Included", caption: onboardingGiftLabel({ giftedDays: days }), selectable: true, statusLabel: "",
  };
}
